import styled from '@emotion/styled';
import { Div } from '../../../../layouts';

export const SwapButtonMobileEl = styled(Div)`
    .odf-rtl && {
      left: 0;
      right: auto;
    }
    && {
        right: 0;
        margin-top: ${(props) => props.isCssVariationMobile ? '-20px' : '-16px'};
    }
`;
